import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { poll, req, reqPoll } from "./ServerUtils"
import CircularProgress from '@mui/material/CircularProgress';
import { NavBar } from "./Navbar";
import Alert from '@mui/material/Alert';
import EditIcon from '@mui/icons-material/Edit';
import RefreshIcon from '@mui/icons-material/Refresh';
import Tooltip from '@mui/material/Tooltip';

import './Fullpost.css';

export function FullPost() {
    const [hook, setHook] = useState(null);
    const [fullPost, setFullPost] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        setLoading(true);

        const urlParams = new URLSearchParams(window.location.search);
        const h = urlParams.get('hook');
        setHook(h);

        req('/full-post?hook=' + h).then((res) => {
            if (res?.full_post) {
                setFullPost(res.full_post)
                setLoading(false);
            } else {
                setError(res?.error || 'Sorry, something went wrong. Please try again later.');
                setLoading(false);
            }
        }).catch((err) => {
            setError(err?.message || 'Sorry, something went wrong. Please try again later.');
            setLoading(false);
        })
    }, []);
    
    return (
        <>
        <NavBar />
        <div style={{

            paddingTop: 30,
        }}>
            
            {(loading || error) && 
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'start',
                    alignItems: 'center',
                    height: '100vh',
                    gap: 10
                }}>
                    {error &&
                        <Alert severity="error">
                            {error}
                        </Alert>
                    }
                    {loading &&
                        <>
                            <div>
                                Please wait, we're generating the full post...
                            </div>
                            <CircularProgress />
                        </>
                    }
                </div>}
                
            {!loading && !error &&
                 <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'start',
                    alignItems: 'center',
                    gap: 20,
                    cursor: 'pointer',
                    fontSize: "1.2rem"
                }} onClick={() => {
                    navigator.clipboard.writeText(fullPost.join('\n\n'));
                }}>
                    <div>Click to Copy this post:</div>
                    <div style={{
                        border: '1px solid #ccc',
                        padding: 20,
                        borderRadius: 10,
                        cursor: 'pointer',

                        display: 'flex',
                        flexDirection: 'column',
                        gap: 10,
                    }} 
                    // contentEditable={true}
                    >
                        {fullPost.map((line, i) => (
                            <div className="full-post-line" key={i}>
                                {line} {
                                    line.length > 0 && 
                                    <Tooltip title="Regenerate this line">
                                        <RefreshIcon className="full-post-refresh-icon" style={{
                                            marginLeft: 10, 
                                            verticalAlign: "middle"
                                        }} onClick={() => {
                                            reqPoll('/redo-post-line?hook=' + hook + '&line=' + line + '&idx=' + i, 'POST', JSON.stringify({
                                                line,
                                                idx: i

                                            })).then((res) => {
                                                console.log("new line = ", res);
                                            })
                                        }} />
                                    </Tooltip>
                                }
                            </div>
                        ))}
                    </div>
                </div>}


        </div>
        </>
    )
}